import { useEffect } from 'react';
import BoundaryLookupService from '@/utils/boundaryLookupService';

/**
 * Hook to manage boundary cache lifecycle
 */
export function useBoundaryCache() {
  useEffect(() => {
    const boundaryService = BoundaryLookupService.getInstance();
    
    // Start background refresh process
    boundaryService.startBackgroundRefresh();
    
    // Cleanup function to stop background refresh when component unmounts
    return () => {
      boundaryService.stopBackgroundRefresh();
    };
  }, []);

  // Return utility functions for cache management
  return {
    clearExpiredCache: async () => {
      const boundaryService = BoundaryLookupService.getInstance();
      await boundaryService.clearExpiredCache();
    },
    getCacheStats: () => {
      const boundaryService = BoundaryLookupService.getInstance();
      return boundaryService.getCacheStats();
    }
  };
}